import DeliveryEntranceTabApp from '../Functionality/DeliveryEntranceTab';
import TrailCard from '../EquipmentAndMaterial/subComponents/TrailCard';
import ActivityTrackerCard from '../EquipmentAndMaterial/subComponents/ActivityTrackerCard';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const DeliveryEntranceTab = (props) => {
    const { t, setShowMarkAsReadModal, onHide, materialId, markAsCompleted, setDisplayModal } = props;
    const {
        delivery,
        dispatch,
        option,
        handleMarkAsCompleted,
        setCommentData,
        activityTracker,
        handleSendMessage,
        setModified,
        modified,
    } = DeliveryEntranceTabApp({ 
        t, 
        setShowMarkAsReadModal, 
        onHide, 
        materialId, 
        markAsCompleted 
    });

    return (
        <>
            {delivery && <TrailCard item={delivery} t={t} dispatch={dispatch} option={option} />}
            <ActivityTrackerCard
                item={delivery}
                comments={activityTracker}
                t={t}
                handleMarkAsCompleted={handleMarkAsCompleted}
                setCommentData={setCommentData}
                handleSendMessage={handleSendMessage}
                modified={modified}
                setModified={setModified}
                setDisplayModal={setDisplayModal}
                onHide={onHide}
            />
        </>
    );
};

export default DeliveryEntranceTab;
